import React from 'react';
import styled from 'styled-components';
import ProjectsContext from './ProjectsContext';
// import FunctionNotificationForm from './FunctionNotificationForm';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
    Divider,
    Paper,
    Modal,
    Button,
    TextField,
    IconButton,
    Icon,
    Dialog,
    Switch
  } from "@material-ui/core";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const Container = styled.div`
    min-width:680px;
    display:flex;
    flex-direction:column;

    // padding-bottom:40px;
`;

const ContainerHeader = styled.div`
    width:100%;
    color: white;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    padding:20px;
    height:80px;
    background-color:RGB(48, 74, 87);
    display:flex;
    align-items:center;
`;

const ContainerSteps = styled.div`
`;

const ButtonsContainer = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:flex-end;
height:80px;
padding-right:20px;
`

const ButtonContainer = styled.div`
width:90px;
margin-left:20px;
`

const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 500;

margin-top: 15px;
margin-left: 15px;
`
const LevelSetDiv = styled.div`
display: flex;
height: 35px;
line-height: 35px;

font-family: Roboto;
font-size: 15px;
font-weight: 500;

margin-top: 15px;
margin-left: 15px;
`

const TextFieldContainer = styled.div`
  width: 95%;
  margin-left: 15px;
  margin-right: 15px;
`;

const ResetNameContainer = styled.div`
  width: 95%;
  display: flex;
  justify-content: flex-end;
  margin-left: 30px;
`;

const DialogTitleContainer = styled.div`
    width:100%
    display:flex;
    align-items:center;
    justify-content:space-between;
`;

export default function ProjectCustomNameDialog() {
    const context = React.useContext(ProjectsContext);
    const selectedProject = context.projects.selectedProjectOrGbu;
    const [checked, setChecked] = React.useState(!context.projects.selectedProjectOrGbu.isActive);
    const [projectPreferredName,setProjectPreferredName] = React.useState(context.projects.selectedProjectOrGbu.preferredName ? context.projects.selectedProjectOrGbu.preferredName : context.projects.selectedProjectOrGbu.name);
    const [projectLevel, setProjectLevel] = React.useState(context.projects.selectedProjectOrGbu.level)

    const handleChange = event => {
        setChecked(event.target.checked);
        // selectedProject.isActive = !event.target.checked;
    };

    const handleLevelChange = event => {
        setProjectLevel(event.target.checked ? 2 : 3);
        // selectedProject.level = event.target.checked ? 2 : 3;
    };

    
    const handleNameChange = event => {
        setProjectPreferredName(event.target.value);
        // selectedProject.preferredName = event.target.value;
    };

    const handleClick = (e) => {
        e.preventDefault();
        setProjectPreferredName(selectedProject.name);
        // selectedProject.preferredName = selectedProject.name;
        console.log('The link was clicked.');
    };

    const handleSave = () => {
        selectedProject.preferredName = projectPreferredName;
        selectedProject.isActive = !checked;
        selectedProject.level = projectLevel;
        context.updateProject(selectedProject);
        context.closeProjectCustomNameDialog();                   
    }

    const handleCancel = () => {
        setChecked(!selectedProject.isActive);
        setProjectPreferredName(selectedProject.preferredName);
        setProjectLevel(selectedProject.level);
        context.closeProjectCustomNameDialog();
    }

    return (
            selectedProject && <Dialog maxWidth='xl' open={context.projectCustomNameDialogOpen}>
            <Container>
                <ContainerHeader>Project Settings</ContainerHeader>
            
                <TextFieldLabel>
                    Project Name
                </TextFieldLabel>
                <TextFieldContainer>
                    <TextField value={projectPreferredName} onChange={handleNameChange}  fullWidth margin="normal" variant="outlined" />
                    {selectedProject.preferredName !== selectedProject.name && selectedProject.preferredName !== null && 
                        <ResetNameContainer><a href="#" onClick={handleClick}>Reset to Default Name</a></ResetNameContainer>}
                </TextFieldContainer>

                <TextFieldLabel>
                    Project Visibility
                </TextFieldLabel>
                <TextFieldContainer>
                    <FormControlLabel
                        control={
                        <Switch checked={checked} onChange={handleChange} name="checked" />
                        }
                        label="Hide project from the application"
                    />
                </TextFieldContainer>
                <LevelSetDiv>
                    <div>
                        Level 3
                    </div>
                    <div>
                        <Switch checked={projectLevel == 2 ? true : false} onChange={handleLevelChange} name="level" />
                    </div>
                    <div>
                        Level 2 
                    </div>
                </LevelSetDiv>
                
                <ButtonsContainer>
                    <ButtonContainer>
                        <Button
                            fullWidth
                                variant="outlined"
                                color="primary"
                                onClick={handleCancel}
                            >
                            Cancel
                        </Button>
                    </ButtonContainer>
                    <ButtonContainer>
                    <Button 
                            fullWidth
                            style={{paddingLeft:10}}
                            variant="contained"
                            color="primary"
                            // disabled={!enableSave}
                            onClick={handleSave}
                            >Save
                        </Button> 
                    </ButtonContainer> 
                </ButtonsContainer>
            </Container>           
        </Dialog>
    );
  }

// class ProjectCustomNameDialog extends React.Component {

//     static contextType = ProjectsContext;

//     constructor(props){

//         super(props);
    
//         let projectPreferredName = '';
//         let isActive = false;
//         if (this.props.context.projects && this.props.context.projects.selectedProjectOrGbu) {
//             projectPreferredName = this.props.context.projects.selectedProjectOrGbu.preferredName ? this.props.context.projects.selectedProjectOrGbu.preferredName : this.props.context.projects.selectedProjectOrGbu.name;
//             isActive = this.props.context.projects.selectedProjectOrGbu ? this.props.context.projects.selectedProjectOrGbu.isActive : false;
//         }
        
        
//         const {
//             preferredName = projectPreferredName,
           
//         } = this.props

//         this.state = {preferredName}

        
        
//     }


//     renderButtons()
//     {

//         // const enableSave = (!this.state.isDeviating && this.state.deviationComments) || 
//         // (this.state.isDeviating && this.state.deviationReasoning && this.state.modifiedProcedureSdn && this.state.modifiedProcedureTitle && this.state.modifiedProcedureUrl);
//         if(this.state && this.state.preferredName) {
//             this.context.projects.selectedProjectOrGbu.preferredName = this.state.preferredName;
//         }

//         return(
//         <ButtonsContainer>
//             <ButtonContainer>
//             <Button
//             fullWidth
//                 variant="outlined"
//                 color="primary"
//                 onClick={() => {
//                     this.context.closeProjectCustomNameDialog();
//                 }}
//             >
//                 Cancel
//             </Button>
//             </ButtonContainer>
//             <ButtonContainer>
//             <Button 
//                 fullWidth
//                 style={{paddingLeft:10}}
//                 variant="contained"
//                 color="primary"
//                 // disabled={!enableSave}
//                 onClick={() => {
//                     this.context.updateProject(this.context.selectProject);
//                     this.context.closeProjectCustomNameDialog();                   
//                 }}
//                 >Save</Button>
//                 </ButtonContainer>
//             </ButtonsContainer>

//         )
//     }

//     render()
//     {
//         const selectedProject = this.context.projects.selectedProjectOrGbu;
//         const [checked, setChecked] = React.useState();
//         const handleChange = event => {
//             setChecked(event.target.checked);
//         };
//         return (
            

//             selectedProject && <Dialog maxWidth='xl' open={this.context.projectCustomNameDialogOpen}>
//                 <Container>
//                     <ContainerHeader>Project Settings</ContainerHeader>
//                     {/* <ContainerSteps>
//                     {selectedProject &&
//                         <FunctionNotificationForm context={this.context}  initialValues={selectedFunctionDetails}/>
//                     }
//                     </ContainerSteps> */}

//                     <TextFieldLabel>
//                         Project Name
//                     </TextFieldLabel>
//                     <TextFieldContainer>
//                         <TextField value={this.state.preferredName} onChange={event => this.setState({preferredName:event.target.value})}  fullWidth margin="normal" variant="outlined" />
//                     </TextFieldContainer>

//                     <TextFieldLabel>
//                         Project Visibility
//                     </TextFieldLabel>
//                     <TextFieldContainer>
//                         <FormControlLabel
//                             control={
//                             <Switch checked={checked} onChange={handleChange} name="checked" />
//                             }
//                             label="Hide project from the application"
//                         />
//                     </TextFieldContainer>
                 

//                 </Container>
//                 {this.renderButtons()}
               
//             </Dialog>
//         )
//     }

// }

// export default ProjectCustomNameDialog;